import type { JSX, PropsWithChildren } from 'react';
import { Flex, useTheme } from '@chakra-ui/react';

import { FileIcon } from '../../icon';
import { NabanCardListItemTitle } from './NabanCardListItemTitle';

type Props = {
  title: string | JSX.Element;
  titleFlexBasis?: string;
  icon?: JSX.Element;
};

export const NabanCardListItem = ({
  children,
  icon,
  title,
  titleFlexBasis = '45%',
}: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <Flex flexDirection='row' py={4} alignItems='center' gap={4} w='full'>
      <Flex
        flexDirection='row'
        alignItems='center'
        gap={4}
        flex={{
          base: 1,
          md: `0 0 ${titleFlexBasis}`,
        }}
        minW={0}>
        {icon ?? (
          <Flex>
            <FileIcon extension='pdf' color={theme.colors.primary400} />
          </Flex>
        )}
        <NabanCardListItemTitle title={title} />
      </Flex>
      {children}
    </Flex>
  );
};
